import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import style from "../AddUpdateSubject/Subject.module.css";
import * as yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid2,
  ListItemText,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import { getDobAgeSelecterData } from "../../../utilities/data";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import NumericPadInput from "../../../components/NumericPadInput";
import { useEffect, useState } from "react";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../../utilities/helper";
import { useNavigate } from "react-router-dom";
import { saveSubjectDataService } from "../../../services/subjectService";
import SubjectConfirmation from "./SubjectConfirmation";
import dayjs from "dayjs";
import FieldRenderer from "./FileRenderer";
import { applyForceDisabled, getPickerViews, normalizeFormat } from "./helper";

const genderGrpArray = [
  { text: "Male", value: "male" },
  { text: "Female", value: "female" },
  { text: "Other", value: "other" },
];

export const DynamicForm = ({
  fieldJsonList,
  allQuestionsData,
  setLoad,
  showConfirm,
  setShowConfirm,
  responseData,
  setResponseData,
  pageName,
  languageData,
  setLanguageData,
  showLinks = true,
}) => {
  const access_token = localStorage.getItem("access_token");

  const roleId = localStorage.getItem("roleId");

  const [preview, setPreview] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [payloadData, setPayloadData] = useState(allQuestionsData);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [recordDataState, setRecordDataState] = useState({
    patientDobFormat: "",
    recordPatientDob: false,
    recordPatientGender: false,
    recordPatientInitials: false,
    useTwentyFourHourTime: "",
  });

  const countryConfigData = allQuestionsData?.countryConfigData || null;
  const errorStateData = allQuestionsData?.patientVisitData?.errors || [];
  const warningStateData = allQuestionsData?.patientVisitData?.warnings || [];
  const hardStopStateData =
    allQuestionsData?.patientVisitData?.hardStop || false;

  const {
    recordPatientDob,
    recordPatientGender,
    recordPatientInitials,
    useTwentyFourHourTime,
  } = recordDataState;

  // const pages = splitFieldsByPageBreak(
  //   fieldJsonList.map(normalizeField).filter(Boolean),
  // );

  const pages = createPages(JSON.parse(fieldJsonList[0])?.pages);

  // const currentFields = pages[currentPageIndex];
  const visiblePages = pages.slice(0, currentPageIndex + 1);

  // Add forceDisabled flag to fields from previous pages
  // const currentFields = visiblePages?.flatMap((page, pageIndex) =>
  //   page.map((field) => ({
  //     ...field,
  //     forceDisabled: pageIndex < currentPageIndex,
  //   })),
  // );
  const currentFields = visiblePages?.flatMap((page, pageIndex) => {
    const shouldDisable = pageIndex < currentPageIndex;
    return applyForceDisabled(page, shouldDisable);
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (responseData) {
      setShowConfirm(true);
    }
  }, [responseData]);

  useEffect(() => {
    if (countryConfigData) {
      setRecordDataState({
        patientDobFormat: countryConfigData?.patientDobFormatText || "",
        recordPatientDob: countryConfigData?.recordPatientDob || false,
        recordPatientGender: countryConfigData?.recordPatientGender || false,
        recordPatientInitials:
          countryConfigData?.recordPatientInitials || false,
        useTwentyFourHourTime:
          countryConfigData?.useTwentyFourHourTime || false,
      });
    }
  }, [countryConfigData]);

  function createPages(pages) {
    let currentPages = [];
    pages?.forEach((item) => {
      currentPages.push(item?.elements);
    });

    return currentPages;
  }

  function normalizeField(jsonString) {
    try {
      const field = JSON.parse(jsonString);
      return {
        id: field.id || field.fieldId,
        type: field.key || field?.element,
        name: field.name || field.field_name,
        label: field.props?.label || field.text || field.name,
        props: field.props || {},
        specialProps:
          {
            isBold: field?.bold,
            isItalic: field?.italic,
            content: field?.content,
          } || {},
        required: field.isRequired || false,
        options: field?.pageTitle?.split(",") || [],
        answer_id: field?.answer_id,
        dependsOn: field?.dependsOn || null,
        hasCondition: field?.hasCondition || false,
        hasValue: field?.hasValue || null,
        doRule: field?.doRule || null,
      };
    } catch (e) {
      console.error("Invalid JSON:", e);
      return null;
    }
  }
  const buildValidationSchema = (fields) => {
    const shape = {};

    fields?.forEach((field) => {
      if (!field.name) return;

      const uniqueName = `${field.name}_${field?.receivedId}`;
      let rule = yup.string();
      if (
        field.type === "DatePicker" ||
        // field?.type == "VisitDatePicker" ||
        (field?.type == "text" && field?.inputType === "date")
      ) {
        rule = yup
          .mixed()
          .nullable()
          .test("is-valid-date", "Date is required", (value) => {
            if (value === null || value === undefined || value === "")
              return true;
            return dayjs(value).isValid();
          });
      } else if (field?.type === "visitdatepicker" || field?.type === "eq5d5l")
        rule = yup.string().nullable();
      else if (
        field.type === "TimePicker" ||
        (field?.type === "text" && field?.inputType === "time")
      )
        rule = yup.string().nullable();
      else if (field?.type === "checkbox") {
        rule = yup.array().of(yup.string());
      } else if (field?.type === "singleCheckbox") {
        rule = yup.string().nullable();
      } else if (field?.type == "file") {
        rule = yup
          .mixed()
          .test("isFile", "Invalid file", (value) => {
            // Allow null, undefined, or a valid File
            return value == null || value instanceof File;
          })
          .nullable();
      }
      // if (field.isRequired)
      //   rule = rule.required(
      //     `${field?.title || field?.label || field?.name} is required`,
      //   );

      if (field.isRequired && field?.type) {
        if (
          field?.type === "ageDateRange" &&
          field?.inputFieldTypeId === 18 &&
          (field?.name?.includes("dobRange") ||
            field?.title?.includes("Birth")) &&
          !recordPatientDob
        ) {
          rule = rule.nullable();
        } else if (
          field?.type === "genderRadioGroup" &&
          field?.inputFieldTypeId === 29 &&
          (field?.name?.includes("gender") ||
            field?.title?.includes("Gender")) &&
          !recordPatientGender
        ) {
          rule = rule.nullable();
        } else if (
          field?.type === "text" &&
          field?.inputFieldTypeId === 6 &&
          field?.title?.toLowerCase() === "initials" &&
          !recordPatientInitials
        ) {
          rule = rule.nullable();
        } else if (
          field?.type === "checkbox"
          // || field?.type === "singleCheckbox"
        ) {
          rule = rule.min(
            1,
            `${field?.title || field?.label || field?.name} is required`,
          );
        } else {
          rule = rule.required(
            `${field?.title || field?.label || field?.name} is required`,
          );
        }
      } else {
        if (
          field?.type === "ageDateRange" &&
          field?.inputFieldTypeId === 18 &&
          (field?.name?.includes("dobRange") ||
            field?.title?.includes("Birth")) &&
          recordPatientDob
        ) {
          rule = rule.required(
            `${field?.title || field?.label || field?.name} is required`,
          );
        } else if (
          field?.type === "genderRadioGroup" &&
          field?.inputFieldTypeId === 29 &&
          (field?.name?.includes("gender") ||
            field?.title?.includes("Gender")) &&
          recordPatientGender
        ) {
          rule = rule.required(
            `${field?.title || field?.label || field?.name} is required`,
          );
        } else if (
          field?.type === "text" &&
          field?.inputFieldTypeId === 6 &&
          field?.title?.toLowerCase() === "initials" &&
          recordPatientInitials
        ) {
          rule = rule.required(
            `${field?.title || field?.label || field?.name} is required`,
          );
        }
      }

      shape[uniqueName] = rule;
    });

    // This is for non-empty fields allowed
    // fields?.forEach((field) => {
    //   if (!field.name) return;

    //   const uniqueName = `${field.name}_${field?.answer_id}`;
    //   let rule = yup.string();

    //   // ❗ Add this test to avoid whitespace-only values
    //   if (
    //     field.type !== "DatePicker" &&
    //     field.type !== "Date" &&
    //     field.type !== "VisitDatePicker" &&
    //     field.type !== "TimePicker" &&
    //     field.type !== "Time" &&
    //     field.type !== "AgeRange" &&
    //     field.type !== "Camera"
    //   ) {
    //     rule = rule.test(
    //       "not-empty",
    //       `${field.label || field.name} cannot be empty or spaces`,
    //       (value) => {
    //         if (value == null) return true;
    //         return String(value).trim().length > 0;
    //       }
    //     );
    //   }

    //   if (field.type === "DatePicker" || field.type === "Date") {
    //     rule = yup
    //       .mixed()
    //       .nullable()
    //       .test("is-valid-date", "Date is required", (value) => {
    //         if (value === null || value === undefined || value === "")
    //           return true;
    //         return dayjs(value).isValid();
    //       });
    //   } else if (field.type === "VisitDatePicker") {
    //     rule = yup.string().nullable();
    //   } else if (field.type === "TimePicker" || field.type === "Time") {
    //     rule = yup.string().nullable();
    //   } else if (field.type === "AgeRange") {
    //     rule = yup.object().shape({
    //       start: yup.string(),
    //       end: yup
    //         .string()
    //         .test(
    //           "is-after-start",
    //           "End date must be on or after start date",
    //           function (endDate) {
    //             const { start } = this.parent;
    //             if (!start || !endDate) return true;
    //             return new Date(endDate) >= new Date(start);
    //           }
    //         ),
    //     });
    //   } else if (field.type === "Camera") {
    //     rule = yup
    //       .mixed()
    //       .test("isFile", "Invalid file", (value) => {
    //         return value == null || value instanceof File;
    //       })
    //       .nullable();
    //   }

    //   if (field.required) {
    //     rule = rule.required(`${field.label || field.name} is required`);
    //   }

    //   shape[uniqueName] = rule;
    // });

    return yup.object().shape(shape);
  };

  // const fields = fieldJsonList.map(normalizeField).filter(Boolean);

  const schema = buildValidationSchema(currentFields);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: buildDefaultValues(currentFields),
  });

  function buildDefaultValues(fields) {
    const defaults = {};

    fields.forEach((field) => {
      const uniqueName = `${field.name}_${field.receivedId}`;

      if (field.type === "checkbox") {
        defaults[uniqueName] = [];
      }
      // else {
      //   defaults[uniqueName] = "";
      // }
    });

    return defaults;
  }

  const formatInitials = (value) => {
    if (!value) return "";

    const trimmed = value.trim();

    if (trimmed.length === 2) {
      return `${trimmed[0]}-${trimmed[1]}`;
    }

    return trimmed;
  };

  const componentMap = {
    // text: ({ label, register, name, isRequired, disabled }) => {
    //   const field = register(name);

    //   return (
    //     <div>
    //       <TextareaAutosize
    //         minRows={3}
    //         className="form-text-area"
    //         disabled={disabled}
    //         type="text"
    //         {...field}
    //         onBlur={(e) => {
    //           // First call RHF's original onBlur
    //           field.onBlur(e);

    //           // Apply formatting only if name starts with "initials_"
    //           if (name?.startsWith("initials_")) {
    //             const formattedValue = formatInitials(e.target.value);

    //             // Update value manually
    //             e.target.value = formattedValue;
    //           }
    //         }}
    //       />
    //     </div>
    //   );
    // },
    text: ({ label, register, name, isRequired, disabled }) => {
      const field = register(name);

      return (
        <div>
          <TextareaAutosize
            minRows={3}
            className="form-text-area"
            disabled={disabled}
            type="text"
            {...field}
            onBlur={(e) => {
              // Apply formatting only if name starts with "initials_"
              if (name?.startsWith("initials_")) {
                const formattedValue = formatInitials(e.target.value);

                // Update input value
                e.target.value = formattedValue;

                // Create a proper change event object for RHF
                const changeEvent = {
                  ...e,
                  target: {
                    ...e.target,
                    value: formattedValue,
                    name: name,
                  },
                };
                field.onChange(changeEvent);
              }
              field.onBlur(e);
            }}
          />
        </div>
      );
    },
    dobAgeSelector: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              displayEmpty
              disabled={disabled}
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {(getDobAgeSelecterData() || []).map((item, index) => (
                <MenuItem key={index} value={item?.key}>
                  {item?.value}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
    ),

    ageDateRange: ({
      label,
      name,
      control,
      isRequired,
      disabled,
      specialProps,
    }) => {
      const minDate = specialProps?.minDate;
      const maxDate = specialProps?.maxDate;

      const dynamicFormat = normalizeFormat(recordDataState.patientDobFormat);
      const { views, openTo } = getPickerViews(dynamicFormat);

      return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                sx={{ width: "100%" }}
                disabled={disabled}
                format={dynamicFormat}
                views={views}
                openTo={openTo}
                value={field.value ? dayjs(field.value, dynamicFormat) : null}
                onChange={(date) => {
                  if (!date) {
                    field.onChange(null);
                    return;
                  }

                  if (!dynamicFormat.includes("DD")) {
                    if (
                      dynamicFormat.includes("MMM") &&
                      dynamicFormat.includes("YYYY")
                    ) {
                      field.onChange(date.format("MMM/YYYY"));
                    } else if (dynamicFormat.includes("YYYY")) {
                      field.onChange(date.format("YYYY"));
                    }
                    return;
                  }

                  field.onChange(date.format(dynamicFormat));
                }}
                minDate={minDate ? dayjs(minDate) : undefined}
                maxDate={maxDate ? dayjs(maxDate) : undefined}
                slotProps={{
                  textField: {
                    placeholder: dynamicFormat,
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      );
    },

    TimePicker: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <input type="time" {...register(name)} disabled={disabled} />
      </div>
    ),

    ageRangeYear: ({
      label,
      register,
      name,
      isRequired,
      disabled,
      specialProps,
    }) => {
      const minValue = specialProps?.minValue;
      const maxValue = specialProps?.maxValue;

      return (
        <div>
          {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
          <TextField
            size="small"
            fullWidth
            type="number"
            disabled={disabled}
            inputProps={{
              maxLength: 4,
              inputMode: "numeric",
              pattern: "[0-9]*",
              min: minValue,
              max: maxValue,
            }}
            {...register(name, {
              required: `${label || name} is required`,
              validate: (value) => {
                if (!/^\d{1,4}$/.test(value))
                  return "Only 1-4 digit whole numbers allowed";
                if (parseInt(value, 10) < 0)
                  return "Negative values not allowed";
                if (minValue !== undefined && parseInt(value, 10) < minValue)
                  return `Value must be at least ${minValue}`;
                if (maxValue !== undefined && parseInt(value, 10) > maxValue)
                  return `Value must be at most ${maxValue}`;
                return true;
              },
              onChange: (e) => {
                const raw = e.target.value;
                // Remove non-digit characters
                const digitsOnly = raw.replace(/\D/g, "").slice(0, 4);
                e.target.value = digitsOnly;
              },
            })}
          />
        </div>
      );
    },

    checkbox: ({ label, name, register, isRequired, disabled, options }) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          gap: "8px",
          margin: "8px 0",
        }}
      >
        {(options || []).map((item, index) => {
          const isObject = typeof item === "object" && item !== null;

          const value = isObject ? item.value : item;
          const text = isObject ? item.text : item;

          return (
            <FormControlLabel
              key={value ?? index}
              control={
                <Checkbox
                  {...register(name)} // same name = array
                  value={value} // IMPORTANT
                  disabled={disabled}
                />
              }
              label={text}
            />
          );
        })}
      </div>
    ),

    Date: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MM-YYYY"
                // FIX 1: Convert stored string → dayjs object for UI
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                // FIX 2: Store only clean date string → no timezone shift
                onChange={(date) => {
                  const formatted = date ? date.format("YYYY-MM-DD") : null;
                  field.onChange(formatted);
                }}
                slotProps={{
                  textField: {
                    placeholder: "DD-MM-YYYY", // 👈 force placeholder
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    eq5d5l: ({ label, name, control, isRequired, disabled, specialProps }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                // value={field.value}
                sx={{ width: "100%" }}
                shouldDisableDate={(date) => {
                  // If specialProps is true, only enable today's date
                  if (specialProps) {
                    const today = dayjs();
                    // Disable all dates except today
                    return !date.isSame(today, "day");
                  }
                  return false; // No restrictions when specialProps is false
                }}
                disabled={disabled}
                format="DD-MM-YYYY"
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                // FIX 2: Store only clean date string → no timezone shift
                onChange={(date) => {
                  const formatted = date ? date.format("YYYY-MM-DD") : null;
                  field.onChange(formatted);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
                slotProps={{
                  textField: {
                    placeholder: "DD-MM-YYYY", // 👈 force placeholder
                  },
                }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    // singleCheckbox: ({ label, name, options, isRequired, disabled }) => (
    //   <div>
    //     {/* <p className="labelStyles">
    //       {label}
    //       {isRequired && <span>*</span>}
    //     </p> */}
    //     <FormControl size="small" fullWidth>
    //       <Controller
    //         name={name}
    //         control={control}
    //         defaultValue={[]} // must be array for multiple select
    //         render={({ field }) => (
    //           <Select
    //             {...field}
    //             multiple
    //             disabled={disabled}
    //             displayEmpty
    //             renderValue={(selected) =>
    //               selected?.length ? selected.join(", ") : "Select"
    //             }
    //           >
    //             {(options || [])?.map((option, index) => (
    //               <MenuItem key={index} value={option}>
    //                 <Checkbox checked={field.value?.includes(option)} />
    //                 <ListItemText primary={option} />
    //               </MenuItem>
    //             ))}
    //           </Select>
    //         )}
    //       />
    //     </FormControl>
    //   </div>
    // ),

    singleCheckbox: ({ label, name, isRequired, disabled, specialProps }) => {
      const checkboxLabel = specialProps || "Yes";

      return (
        <FormControl size="small" fullWidth>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.value === checkboxLabel}
                    onChange={(e) =>
                      field.onChange(e.target.checked ? checkboxLabel : null)
                    }
                    disabled={disabled}
                  />
                }
                label={checkboxLabel}
              />
            )}
          />
        </FormControl>
      );
    },

    Time: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => {
              const timeValue =
                typeof field.value === "string"
                  ? dayjs(field.value, "hh:mm A") // Parse as 12-hour format
                  : field.value;

              return (
                <TimePicker
                  ampm // enables AM/PM mode
                  sx={{ width: "100%" }}
                  value={timeValue}
                  disabled={disabled}
                  onChange={(time) => {
                    if (time && dayjs(time).isValid()) {
                      field.onChange(time.format("hh:mm A")); // Save in AM/PM format
                    } else {
                      field.onChange(null);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              );
            }}
          />
        </LocalizationProvider>
      </div>
    ),

    dropdown: ({ label, name, register, options, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              disabled={disabled}
              displayEmpty
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* {(options || []).map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))} */}
              {(options || []).map((item, index) => {
                const isObject = typeof item === "object" && item !== null;

                const value = isObject ? item.value : item;
                const label = isObject ? item.text : item;

                return (
                  <MenuItem key={index} value={value}>
                    {label}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
      </div>
    ),

    dispenseDrugKit: ({
      label,
      name,
      register,
      options,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              displayEmpty
              disabled={disabled}
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {(options || []).map((item, index) => {
                const isObject = typeof item === "object" && item !== null;

                const value = isObject ? item.value : item;
                const label = isObject ? item.text : item;

                return (
                  <MenuItem key={index} value={value}>
                    {label}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
      </div>
    ),

    assignedDrugKit: ({
      label,
      name,
      register,
      options,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              displayEmpty
              disabled={disabled}
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {(options || []).map((item, index) => {
                const isObject = typeof item === "object" && item !== null;

                const value = isObject ? item.value : item;
                const label = isObject ? item.text : item;

                return (
                  <MenuItem key={index} value={value}>
                    {label}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
      </div>
    ),

    numericPad: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <NumericPadInput
              label={label}
              disabled={disabled}
              name={name}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    ),

    singleradio: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Radio
                  checked={field.value === true}
                  disabled={disabled}
                  onChange={(e) => field.onChange(e.target.checked)}
                />
              }
              label={label}
            />
          )}
        />
      </div>
    ),

    genderRadioGroup: ({
      label,
      name,
      control,
      isRequired,
      disabled,
      options,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <RadioGroup {...field} row>
              {(options || genderGrpArray).map((item, index) => {
                const isObject = typeof item === "object" && item !== null;

                const value = isObject ? item.value : item;
                const label = isObject
                  ? item.text
                  : item.charAt(0).toUpperCase() + item.slice(1);

                return (
                  <FormControlLabel
                    key={index}
                    value={value}
                    disabled={disabled}
                    control={<Radio />}
                    label={label}
                  />
                );
              })}
            </RadioGroup>
          )}
        />
      </div>
    ),

    TimeTwo: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <TimePicker
                sx={{
                  width: "100%",
                }}
                value={field.value}
                disabled={disabled}
                onChange={(time) => field.onChange(time)}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    file: ({ label, name, control, isRequired, disabled }) => {
      return (
        <div>
          {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}

          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <>
                <input
                  accept="image/*"
                  type="file"
                  capture="environment"
                  style={{ display: "none" }}
                  disabled={disabled}
                  id={`camera-input-${name}`}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setPreview(URL.createObjectURL(file));
                      field.onChange(file);
                    }
                  }}
                />
                <label htmlFor={`camera-input-${name}`}>
                  <Button variant="outlined" component="span">
                    Upload / Capture Image
                  </Button>
                </label>

                {preview && (
                  <Box mt={2}>
                    <img
                      src={preview}
                      alt="preview"
                      style={{
                        width: "70%",
                        maxHeight: 600,
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                )}
              </>
            )}
          />
        </div>
      );
    },

    HotSpot: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    None: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    visitdatepicker: ({ label, name, control, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                value={field.value}
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MMM-YYYY"
                onChange={(date) => {
                  const formatted = date
                    ? dayjs(date).format("YYYY-MM-DD")
                    : null;
                  field.onChange(formatted);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            )}
          />
        </LocalizationProvider> */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <DatePicker
                sx={{ width: "100%" }}
                disabled={disabled}
                format="DD-MM-YYYY"
                slotProps={{
                  textField: {
                    placeholder: "DD-MM-YYYY",
                  },
                }}
                maxDate={dayjs()}
                // FIX 1: Convert stored string → dayjs object for UI
                value={field.value ? dayjs(field.value, "YYYY-MM-DD") : null}
                // FIX 2: Store only clean date string → no timezone shift
                onChange={(date) => {
                  const formatted = date ? date.format("YYYY-MM-DD") : null;
                  field.onChange(formatted);
                }}
              />
            )}
          />
        </LocalizationProvider>
      </div>
    ),

    singleSelectCheckbox: ({
      label,
      name,
      control,
      options,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}

        <Controller
          name={name}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <Select
              {...field}
              fullWidth
              size="small"
              displayEmpty
              disabled={disabled}
              renderValue={(selected) => {
                const found = (options || []).find((item) => {
                  if (typeof item === "object" && item !== null) {
                    return item.value === selected;
                  }
                  return item === selected;
                });

                if (!found) return "Select";

                return typeof found === "object" ? found.text : found;
              }}
            >
              {(options || []).map((item, index) => {
                const isObject = typeof item === "object" && item !== null;

                const value = isObject ? item.value : item;
                const label = isObject ? item.text : item;

                return (
                  <MenuItem key={value ?? index} value={value}>
                    <Checkbox
                      checked={field?.value === value}
                      sx={{ paddingRight: 1 }}
                    />
                    <ListItemText primary={label} />
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
      </div>
    ),

    NRS: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    videourl: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    patientVisitDrugKitStatus: ({
      label,
      register,
      name,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    replaceDrugKit: ({
      label,
      name,
      register,
      options,
      isRequired,
      disabled,
    }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Select
              size="small"
              fullWidth
              disabled={disabled}
              displayEmpty
              value={field.value || ""} // Ensure controlled
              onChange={(e) => {
                field.onChange(e.target.value);
              }} // Bind change
              inputRef={field.ref} // Ref support
              onBlur={field.onBlur} // Validation on blur
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* {(options || []).map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))} */}
              {(options || []).map((item, index) => {
                const isObject = typeof item === "object" && item !== null;

                const value = isObject ? item.value : item;
                const label = isObject ? item.text : item;

                return (
                  <MenuItem key={index} value={value}>
                    {label}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        />
      </div>
    ),

    vas: ({ label, register, name, isRequired, disabled }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <TextField
          disabled={disabled}
          size="small"
          fullWidth
          type="text"
          {...register(name)}
        />
      </div>
    ),

    headertext: ({ label, name, isRequired, specialProps }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <h2
          dangerouslySetInnerHTML={{ __html: specialProps }}
          style={{
            fontStyle: `${specialProps?.isItalic ? "italic" : ""}`,
            fontWeight: `${specialProps?.isBold ? "bold" : ""}`,
          }}
        >
          {/* {specialProps || name} */}
        </h2>
      </div>
    ),

    paragraphtext: ({ label, name, isRequired, specialProps }) => (
      <div>
        {/* <p className="labelStyles">
          {label}
          {isRequired && <span>*</span>}
        </p> */}
        <p
          dangerouslySetInnerHTML={{ __html: specialProps }}
          style={{
            fontStyle: `${specialProps?.isItalic ? "italic" : ""}`,
            fontWeight: `${specialProps?.isBold ? "bold" : ""}`,
          }}
        >
          {/* {specialProps?.content || name} */}
        </p>
      </div>
    ),
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    const fixedJSON = fieldJsonList[fieldJsonList?.length - 1];

    for (const item of payloadData?.patientVisitData?.questionnaire
      ?.questions || []) {
      let answers = item?.answers?.[0];
      let inputFieldTypeId = item?.inputFieldTypeId;
      let choices = item?.choices;

      if (!answers) continue;
      delete answers.choiceId;

      for (const key in data) {
        if (!data.hasOwnProperty(key)) continue;

        let value = data[key];
        const changedAnswerId = key?.split("_")[1];
        if (changedAnswerId !== answers?.questionId) continue;

        // 🔍 Handle Camera (File) input
        if (value instanceof File) {
          try {
            const base64 = await convertToBase64(value);
            answers.freeTextAnswer = base64;
            answers.value = base64;
          } catch (error) {
            console.error("Error converting image to base64:", error);
          }
        } else if (value instanceof Object && value?.start && value?.end) {
          answers.freeTextAnswer = JSON.stringify(value);
          answers.value = JSON.stringify(value);
        } else if (Array.isArray(value)) {
          let newValue = value.join(" ,");
          answers.freeTextAnswer = newValue;
          answers.value = newValue;
        } else {
          if (value instanceof Object) {
            answers.freeTextAnswer = "";
            answers.value = "";
          } else {
            if (
              inputFieldTypeId === 1 &&
              item?.choices &&
              item?.choices?.length > 0
            ) {
              let new_choiceId = choices?.find(
                (item) => item?.value == value,
              )?.id;
              if (new_choiceId) {
                answers.choiceId = new_choiceId;
              }
            }
            answers.freeTextAnswer = value;
            answers.value = value;
          }
        }
      }
      item.json = fixedJSON;
    }

    try {
      setLoad(true);
      payloadData.patientVisitData.questionnaire.dosageChangeNeeded = "false";
      const res = await saveSubjectDataService(
        access_token,
        payloadData?.patientVisitData?.questionnaire,
        roleId,
        selectedLanguage,
      );
      if (
        res?.data?.status == 200 &&
        res?.data?.result?.patientVisitData?.questionnaire
      ) {
        const updatedData = res?.data?.result?.patientVisitData?.questionnaire;
        const languageData = res?.data?.result?.language;
        setResponseData({ ...updatedData });
        if (setLanguageData !== null) {
          setLanguageData(languageData);
        }
        setLoad(false);
        notifySuccess(res?.data?.message);
      } else if (res?.data?.status === "400") {
        notifyWarning(res?.data?.message);
      } else if (
        res?.data?.status === "409" &&
        res?.data?.message === "Failed!"
      ) {
        notifyError(res?.data?.result?.patientVisitData?.errors?.[0]);
      }
    } catch (err) {
      setLoad(false);
      console.log("Error", err);
      const errorData = err?.response?.data?.errors;
      const extractedErrors = [];

      for (const key in errorData) {
        if (errorData.hasOwnProperty(key)) {
          const messages = errorData[key];
          const match = key.match(/\[(\d+)\]/);
          if (match && messages.length > 0) {
            const quesNo = parseInt(match[1], 10);
            const message = messages[0]; // first message only
            extractedErrors.push({ quesNo, message });
          }
        }
      }
      const fields = fieldJsonList.map(normalizeField).filter(Boolean);
      if (extractedErrors.length > 0) {
        notifyError(
          fields[extractedErrors[0].quesNo]?.name +
            " " +
            extractedErrors[0].message,
        );
      }
      if (err?.status == 404) {
        navigate("/unauthorize");
      }
    } finally {
      setLoad(false);
    }
  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      if (!(file instanceof Blob)) {
        reject("Not a valid File or Blob");
      }
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });

  return showConfirm && responseData ? (
    <SubjectConfirmation
      data={responseData}
      pageName={pageName}
      languageData={languageData}
      showLinks={showLinks}
    />
  ) : (
    <Box
      component="form"
      autoComplete="off"
      sx={{ height: "auto", width: "100%" }}
      onSubmit={(e) => {
        e.preventDefault(); // <-- this stops rogue submit
        handleSubmit((data) => onSubmit(data, e))(e);
      }}
    >
      {warningStateData && warningStateData?.length > 0 && (
        <div className={style.WarningContainer}>
          <ul>
            {warningStateData?.map((error, index) => (
              <li
                style={{
                  fontSize: "medium",
                }}
                key={index}
              >
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}

      {errorStateData && errorStateData?.length > 0 && (
        <div className={style.errorWarningContainer}>
          <ul>
            {errorStateData?.map((error, index) => (
              <li
                style={{
                  fontSize: "medium",
                }}
                key={index}
              >
                {error}
              </li>
            ))}
          </ul>
        </div>
      )}

      <Grid2
        container
        alignItems="center"
        justifyContent={"space-between"}
        sx={{ width: "100%", margin: "0 auto" }}
        gap={1}
      >
        {/* rendering site languages if any */}
        {payloadData?.siteLanguageList &&
          payloadData?.siteLanguageList?.length > 0 && (
            <Grid2
              size={{ xl: 12, md: 12, lg: 12, sm: 12, xs: 12 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                mb: 3,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                {/* Label */}
                <div
                  style={{
                    flex: "0 0 250px",
                    textAlign: "right",
                    wordWrap: "break-word",
                    paddingTop: "8px",
                  }}
                >
                  Language
                </div>
                <div
                  style={{
                    flex: 1,
                    maxWidth: "400px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Select
                    id="language"
                    fullWidth
                    size="small"
                    disabled={hardStopStateData}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                    value={selectedLanguage || ""}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {payloadData?.siteLanguageList &&
                      payloadData?.siteLanguageList?.map((item, index) => (
                        <MenuItem value={item?.id} key={index}>
                          {item?.name}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              </div>
            </Grid2>
          )}

        {currentFields?.map((field, index) => (
          <FieldRenderer
            key={index}
            field={field}
            index={index}
            control={control}
            register={register}
            errors={errors}
            componentMap={componentMap}
            currentFields={currentFields}
            hardStop={hardStopStateData || false}
          />
        ))}
      </Grid2>
      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          {currentPageIndex > 0 ? (
            <button
              type="button"
              className="create-btn-outlined"
              onClick={() => setCurrentPageIndex((prev) => prev - 1)}
            >
              Back
            </button>
          ) : (
            <button
              type="button"
              className="create-btn-outlined"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                navigate("/subject");
              }}
            >
              Cancel
            </button>
          )}
        </Grid2>
        <Grid2 item md={6}>
          {currentPageIndex < pages.length - 1 ? (
            <button
              type="button"
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isValid = await trigger(); // only validate current page
                if (isValid) {
                  setCurrentPageIndex((prev) => prev + 1);
                }
              }}
              className="create-btn"
            >
              Next
            </button>
          ) : (
            <button
              type="submit"
              className={hardStopStateData ? "disabled-btn" : "create-btn"}
              disabled={hardStopStateData}
            >
              Save
            </button>
          )}
        </Grid2>
      </Grid2>
    </Box>
  );
};
